import { render, staticRenderFns } from "./SupportDevices.vue?vue&type=template&id=64f8797b"
import script from "./SupportDevices.vue?vue&type=script&lang=js"
export * from "./SupportDevices.vue?vue&type=script&lang=js"
import style0 from "./SupportDevices.vue?vue&type=style&index=0&id=64f8797b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports